<template>
  <div>

    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>Pictures</h3>
        <view-image :key="p" :src="p" v-for="p in photos"/>
      </md-dialog-content>
      <md-dialog-actions>
        <download-pictures-button :pics="photos"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-card class="searchPanel">
       <md-card-expand>
        <md-card-expand-content>
        <md-card-content>
          
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-30 md-small-size-100">

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>Load Id</label>
                  <md-input v-model="searchRequest.loadIdFrom" @keyup.enter="doSearch"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>To</label>
                  <md-input v-model="searchRequest.loadIdTo" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>

            <auto-complete-master-data-multiple-select
                    label="Load Status"
                    :prepared-options="loadStatusOptions"
                    v-model="searchRequest.loadStatus"
            />
          </div>
          <div class="md-layout-item md-size-30 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.etaStart">
                  <label>ETA Date</label>
                </datepicker>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.etaEnd">
                  <label>To</label>
                </datepicker>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.deliveryStart">
                  <label>Delivery Date</label>
                </datepicker>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.deliveryEnd">
                  <label>To</label>
                </datepicker>
              </div>
            </div>

            <md-checkbox v-model="filterUpdatedToSapFail" v-if="getRole.isAcnIT">
              Show only update to SAP failed
            </md-checkbox>
          </div>

          <div class="md-layout-item md-size-40 md-small-size-100">

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                        group="Hauler"
                        label="Hauler"
                        v-model="searchRequest.haulerIds">
                </auto-complete-master-data-multiple-select>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                        group="State"
                        label="State"
                        v-model="searchRequest.states">
                </auto-complete-master-data-multiple-select>
              </div>

              
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                        :prepared-options="getDriverGroupOptionsForUser"
                        label="Driver Group"
                        v-model="searchRequest.driverGroups">
                </auto-complete-master-data-multiple-select>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                        :preparedOptions="drivers"
                        label="Driver"
                        v-model="searchRequest.drivers"
                        display-type="idOnly"
                        >
                </auto-complete-master-data-multiple-select>
              </div>


              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-search-store-multiple-select
                        multiple="true"
                        ref="SelectStore"
                        label="Store"
                        :join-end-outlets="true"
                        v-model="searchRequest.storeIds">
                </auto-complete-search-store-multiple-select>
              </div>
            </div>
          </div>


        </div>
      </md-card-content>
      
      </md-card-expand-content>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <template v-if="getPermission.loads.edit">
              <calling-api path="/api/w/loads/save">
                <md-button class="md-raised" :disabled="!canConfirm" @click="doConfirm">Confirm</md-button>
                <md-button class="md-raised" :disabled="!canUnConfirm" @click="doUnConfirm">UnConfirm</md-button>
                <md-button class="md-raised" :disabled="!canChange" @click="doChange">Change</md-button>
                <md-button class="md-raised" :disabled="!canSave" @click="doSave">Save</md-button>
                <md-button class="md-raised" :disabled="!canNew" @click="doNew">New</md-button>
              </calling-api>
            </template>
          </div>
          <div class="md-layout-item md-size-30 md-small-size-100">
            <md-card-actions>
              <calling-api path="/api/w/excel/generate">
                <md-button v-if="getPermission.loads.edit" class="md-raised" @click="toggleUpload">Upload</md-button>
                <md-button v-if="loads.length > 0" class="md-raised" @click="doDownloadExcel">Download</md-button>
                <input type="file" class="md-hide" id="upload-file" accept=".xls,.xlsx" @change="handleFileSelected"/>
              </calling-api>
            </md-card-actions>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            
              <md-card-actions>
                <calling-api path="/api/w/loads">
                <md-button @click="doSearch" class="md-primary md-raised">Search</md-button>
                <md-button @click="clearSearch" class="md-raised">Clear</md-button>
            </calling-api>
             <md-card-expand-trigger>
            <md-button class="md-icon-button" id="expand-button">
              <md-icon>keyboard_arrow_down</md-icon>
            </md-button>
          </md-card-expand-trigger>
         
              </md-card-actions>
           
          </div>
        </div>
      </md-card-content>
        
        
        
       </md-card-expand>
    </md-card>


    <br/>

    <pagination :items="getLoadsToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2-5" v-if="getPermission.loads.edit">
                      <md-checkbox v-model="allItemsSelected" @change="handleAllItemSelectedChanged">
                      </md-checkbox>
                    </th>
                    <th class="header-cell w4">
                      Confirmed
                    </th>
                    <th class="header-cell w4">Load Type</th>
                    <th class="header-cell w4">Load Status</th>
                    <th class="header-cell w8">Driver Group</th>
                    <th class="header-cell w8">
                      <sort :sort.sync="sort" field="loadIdForSort">
                        Load Id
                      </sort>
                    </th>
                    <th class="header-cell w8">ETA Assigned</th>
                    <th class="header-cell w8">
                      <sort :sort.sync="sort" field="rawDeliveryDate">
                        Delivery End Date
                      </sort>
                    </th>
                    <th class="header-cell w8">End Outlet</th>
                    <th class="header-cell w6">Scale Ticket</th>
                    <th class="header-cell w6">Total Bales</th>
                    <th class="header-cell w6">Total weight</th>
                    <th class="header-cell w6">Weight Unit</th>
                    <th class="header-cell w6">Haulier</th>
                    <th class="header-cell w8">Driver</th>
                    <th class="header-cell w8">Delivery Start Date</th>
                    <th class="header-cell w6">Delivery Start Time</th>
                    <th class="header-cell w6">Delivery End Time</th>
                    <th class="header-cell w6">Photo Link</th>
                    <th class="header-cell w6">Yard QC</th>
                    <th class="header-cell w6">Create Person</th>
                    <th class="header-cell w6">Create Date</th>
                    <th class="header-cell w6">Create Time</th>
                    <th class="header-cell w6">Confirmed Person</th>
                    <th class="header-cell w6">Confirmed Date</th>
                    <th class="header-cell w6">Confirmed Time</th>
                    <th class="header-cell w6">Change Person</th>
                    <th class="header-cell w6">Change Date</th>
                    <th class="header-cell w6">Change Time</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w6">Updated to SAP</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w6">Updated to SAP Date</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w15">Updated to SAP message</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr :key="item.loadIdForSort" class="" v-for="item in pageItems">
                    <td class="body-cell w2-5" v-if="getPermission.loads.edit">
                      <md-checkbox :disabled="!!item.confirmedBy" v-model="item.selected"/>
                    </td>
                    <td class="body-cell w4">
                      <md-checkbox disabled v-model="item.confirmed"/>
                    </td>
                    <td class="body-cell w4">
                      {{loadTypeDesc(item.loadType)}}
                    </td>
                    <td class="body-cell w4">
                      {{item.loadStatus}}
                    </td>
                    <td class="body-cell w8">
                      <template v-if="canEditCommonFields(item)">
                        <driver-group-select
                                v-model="item.driverGroup">
                        </driver-group-select>
                      </template>
                      <template v-else>
                        {{item.driverGroup}}
                      </template>
                    </td>
                    <td class="body-cell w8">
                      <template v-if="item.isNew">
                        <md-field>
                          <md-input v-model="item.loadIdAssigned"/>
                        </md-field>
                      </template>
                      <template v-else>
                        {{item.loadIdAssigned}}
                      </template>
                    </td>
                    <td class="body-cell w8">
                      {{item.etaDate | date}}
                    </td>
                    <td class="body-cell w8">
                      <template v-if="item.isChanging || item.isNew">
                        <md-field>
                          <md-input v-model="item.deliveryDateString"/>
                        </md-field>
                        <span class="md-error" v-if="isDateNotValid(item.deliveryDateString)">Invalid format</span>
                      </template>
                      <template v-else>
                        {{item.deliveryDate | date}}
                      </template>
                    </td>
                    <td class="body-cell w8">
                      <template v-if="item.isChanging || item.isNew">
                        <master-data-select group="EndOutlet" displayType="idOnly" v-model="item.endOutlet"/>
                      </template>
                      <master-data-display v-else group="EndOutlet" :tag-id="item.endOutlet"/>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.isChanging || item.isNew">
                        <md-field>
                          <md-input v-model="item.scaleTicket"/>
                        </md-field>
                      </template>
                      <template v-else>
                        {{item.scaleTicket}}
                      </template>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.isChanging || item.isNew">
                        <md-field>
                          <md-input type="number" v-model="item.totalBales"/>
                        </md-field>
                      </template>
                      <template v-else>{{item.totalBales}}</template>

                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.isChanging || item.isNew">
                        <md-field>
                          <template v-if="!item.totalWeight || item.totalWeight < 25000 || item.totalWeight > 45000">
                            <md-icon style="font-size: 20px!important;">
                              error_outline
                            </md-icon>
                            <md-tooltip>Total weight should between 25000~45000</md-tooltip>
                          </template>
                          <md-input style="max-width: 80px" type="number" v-model="item.totalWeight"/>
                        </md-field>
                      </template>
                      <template v-else>
                        <template v-if="!item.totalWeight || item.totalWeight < 25000 || item.totalWeight > 45000">
                          <md-icon style="font-size: 20px!important;">
                            error_outline
                          </md-icon>
                          <md-tooltip>Total weight should between 25000~45000</md-tooltip>
                        </template>
                        {{item.totalWeight | withComma}}
                      </template>
                    </td>
                    <td class="body-cell w6">
                      {{item.weightUnit}}
                    </td>

                    <td class="body-cell w6">
                      {{item.haulerId}}
                    </td>
                    <td class="body-cell w8">
                      <template v-if="canEditCommonFields(item)">
                        <div style="min-width:160px" v-if="drivers">
                          <auto-complete-master-data-select
                                  display-type="idOnly"
                                  :prepared-options="drivers"
                                  :init-value-id="item.driverId"
                                  :watch-value-id="item.updateDriverId"
                                  :on-item-changed="handleDriverChanged(item)">
                          </auto-complete-master-data-select>
                        </div>
                      </template>
                      <template v-else>
                        <template v-if="item.driver">
                          {{item.driver.name}}
                        </template>
                      </template>
                    </td>

                    <td class="body-cell w8">
                      <template v-if="canEditCommonFields(item)">
                        <md-field>
                          <md-input v-model="item.deliveryStartDateString"/>
                        </md-field>
                        <span class="md-error" v-if="isDateNotValid(item.deliveryStartDateString)">Invalid format</span>
                      </template>
                      <template v-else>
                        {{item.deliveryStart | date}}
                      </template>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="canEditCommonFields(item)">
                        <md-field>
                          <md-input v-model="item.deliveryStartTimeString"/>
                        </md-field>
                        <span class="md-error" v-if="isTimeNotValid(item.deliveryStartTimeString)">Invalid format</span>
                      </template>
                      <template v-else>
                        {{item.deliveryStart | time}}
                      </template>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="canEditCommonFields(item)">
                        <md-field>
                          <md-input v-model="item.deliveryTimeString"/>
                        </md-field>
                        <span class="md-error" v-if="isTimeNotValid(item.deliveryTimeString)">Invalid format</span>
                      </template>
                      <template v-else>
                        {{item.deliveryDate | time}}
                      </template>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.photos.length > 0">
                        <a href="" @click.prevent="toggleItemPhoto(item.photos)">{{item.photos.length}} photos</a>
                      </template>
                      <template v-else>
                        <span>0 photos</span>
                      </template>
                    </td>
                    <td class="body-cell w6">
                      {{item.qcStatus}}
                    </td>
                    <td class="body-cell w6">
                      {{item.createdBy}}
                    </td>
                    <td class="body-cell w6">
                      {{item.createdAt | date}}
                    </td>
                    <td class="body-cell w6">
                      {{item.createdAt | time}}
                    </td>
                    <td class="body-cell w6">
                      {{item.confirmedBy}}
                    </td>
                    <td class="body-cell w6">
                      {{item.confirmedAt | date}}
                    </td>
                    <td class="body-cell w6">
                      {{item.confirmedAt | time}}
                    </td>
                    <td class="body-cell w6">
                      {{item.updatedBy}}
                    </td>
                    <td class="body-cell w6">
                      {{item.updatedAt | date}}
                    </td>
                    <td class="body-cell w6">
                      {{item.updatedAt | time}}
                    </td>
                    <td v-if="getRole.isAcnIT" class="body-cell w6">{{item.updatedToSap}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w6">{{item.updatedToSapAt | date}} {{item.updatedToSapAt | time}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w15">{{item.updatedToSapMessage}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>

</style>

<script>
  import { mapGetters } from 'vuex';
  import toGenerateExcelRequest from '../utils/excel';
  import parseXls from '../utils/parseXls';
  import validateTime from '../utils/validate-time';
  import validateDate from '../utils/validate-date';
  import dateFormat from '../utils/dateFormat';
  import { sortList } from '../utils/sort';

  const loadStatusOptions = [
    {
      id: ' ',
      name: 'Created from Schedule',
    },
    {
      id: 'C',
      name: 'Created from App',
    },
    {
      id: 'X',
      name: 'Load Changed',
    },
    {
      id: 'Y',
      name: 'Load Confirmed',
    },
    {
      id: '1',
      name: 'Load Manual',
    },
    {
      id: '9',
      name: 'Load Manual Confirmed',
    },
  ];

  function getInitSearchRequest() {
    return {
      loadStatus: [' ', 'C', 'X', '1'],
      etaStart: null,
      etaEnd: null,
      loadIdFrom: null,
      loadIdTo: null,
      deliveryStart: null,
      deliveryEnd: null,
      haulerIds: [],
      driverGroups: [],
      states: [],
      storeIds: [],
      drivers:[]
    };
  }

  export default {
    data: () => ({
      searchRequest: getInitSearchRequest(),
      loads: [],
      loadStatusOptions,
      drivers: null,
      sort: {
        field: `loadIdForSort`,
        ascending: true,
      },
      allItemsSelected: false,
      filterUpdatedToSapFail: false,
      isPictureModalShowing: false,
      photos: [],
    }),
    computed: {
      ...mapGetters([
        'getRole',
        'getLoads',
        'getUserProfile',
        'getMasterDataName',
        'getDriverGroupOptionsForUser',
        'getPermission',
      ]),
      getLoadsToDisplay() {
        if (this.filterUpdatedToSapFail) {
          return _(sortList(this.loads, this.sort))
            .filter(it => it.updatedToSap === false);
        }
      
        return sortList(this.loads, this.sort);
      },
      getSelectedItems() {
        return _(this.getLoadsToDisplay)
          .filter(it => it.selected === true);
      },
      canConfirm() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }
        if (_(this.getSelectedItems)
          .find(it => it.isNew === true)) {
          return false;
        }
        if (_(this.getSelectedItems)
          .find(it => it.childLoadId && it.childCompleted !== true)) {
          return false;
        }
        const confirmStatus = ['X', 'C', '1'];
        return !_(this.getSelectedItems)
          .find(it => !_(confirmStatus)
            .contains(it.loadStatus));
      },
      canUnConfirm() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }
        if (_(this.getSelectedItems)
          .find(it => it.isNew === true)) {
          return false;
        }
        if (_(this.getSelectedItems)
          .find(it => !!it.confirmedBy)) {
          return false;
        }
        const confirmStatus = ['Y', '9'];
        return !_(this.getSelectedItems)
          .find(it => !_(confirmStatus)
            .contains(it.loadStatus) || !it.confirmed);
      },
      canChange() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }
        if (_(this.getSelectedItems)
          .find(it => it.isNew === true)) {
          return false;
        }
        if (_(this.getSelectedItems)
          .find(it => !!it.confirmedBy)) {
          return false;
        }
        const confirmStatus = [' ', 'C', 'Y', '1'];
        return !_(this.getSelectedItems)
          .find(it => !_(confirmStatus)
            .contains(it.loadStatus));
      },
      canSave() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }
        return true;
      },
      canNew() {
        return !_(this.loads)
          .find(it => it.isNew);
      },
    },
    watch: {
      getLoads(val) {
        this.updateCachedLoadsFromApi(val);
        
      },
    },
    mounted() {
      console.log("get load")
      this.$el.querySelector('#expand-button')
        .click();
      this.updateCachedLoadsFromApi(this.getLoads);
      const cachedSearchRequest = this.$store.state.load.searchRequest;
      if (cachedSearchRequest && !_(cachedSearchRequest)
        .isEmpty()) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      }
      this.$store.dispatch('getUsersByCategory', { category: 'A' })
        .then((res) => {
          this.drivers = res;
          
        });
       
    },
    methods: {
      loadTypeDesc(loadType) {
        if (loadType === "MK2_1" || loadType === "MK2_2") {
          return "Milk Run 2";
        } else if (loadType === "MK1_1" || loadType === "MK1_2") {
          return "Milk Run 1";
        }
        return "Milk Run";
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      handleDriverChanged(item) {
        return (id) => {
          if (item.isNew) {
            item.driverId = id;
          } else {
            item.updateDriverId = id;
          }
        };
      },
      isDateNotValid(value) {
        if (value) {
          const valid = validateDate(value);
          return !valid;
        }
        return false;
      },
      isTimeNotValid(value) {
        if (value) {
          const valid = validateTime(value);
          return !valid;
        }
        return false;
      },
      canEditCommonFields(item) {
        return item.isNew || (item.isChanging && item.loadStatus !== 'C');
      },
      updateCachedLoadsFromApi(newLoads) {
        const loads = JSON.parse(JSON.stringify(newLoads));
        _(loads)
          .each((it) => {
            it.isChanging = false;
            it.selected = false;
            it.rawDeliveryDate = it.deliveryDate;
            it.deliveryDateString = dateFormat.date(it.deliveryDate);
            it.deliveryTimeString = dateFormat.time(it.deliveryDate);
            it.deliveryStartDateString = dateFormat.date(it.deliveryStart);
            it.deliveryStartTimeString = dateFormat.time(it.deliveryStart);
            it.updateDriverId = null;
            it.loadIdForSort = it.loadIdAssigned;
            it.photos = !!it.signature ? [it.signature] : [];
          });
        this.loads = loads;
      },
      doSearch() {
        this.loads = [];
        this.$store.dispatch('loadLoads', this.searchRequest)
          .then(this.updateTableHeight);
      },
      clearSearch() {
        _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
          });
        this.$nextTick(() => {
          this.searchRequest = getInitSearchRequest();
        });
      },
      toggleUpload() {
        this.$el.querySelector('#upload-file')
          .click();
      },
      handleFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((rows) => {
              rows.shift();

              this.loads = _(rows)
                .map(data => ({
                  isNew: true,
                  selected: true,
                  loadIdAssigned: data[0],
                  etaDate: dateFormat.tryDateFromExcel(data[1]),
                  loadStatus: '1',
                  driverId: data[6],
                  driverGroup: null,
                  deliveryStartDateString: dateFormat.date(dateFormat.tryDateFromExcel(data[2])),
                  deliveryStartTimeString: dateFormat.time(moment(data[3], 'HH:mm:ss')
                    .toDate()),
                  deliveryDateString: dateFormat.date(dateFormat.tryDateFromExcel(data[4])),
                  deliveryTimeString: dateFormat.time(moment(data[5], 'HH:mm:ss')
                    .toDate()),
                  haulerId: data[7],
                  totalBales: data[8],
                  totalWeight: data[9],
                  weightUnit: data[10],
                  scaleTicket: data[11],
                  qcStatus: data[12],
                }));
              this.$el.querySelector('#upload-file').value = '';
            });
        }
      },
      doDownloadExcel() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Loads.xls',
          1,
        );
        request.heads = _(request.heads)
          .take(27);

        request.rows = _(this.getLoadsToDisplay)
          .map(item => [
            item.confirmed,
            this.loadTypeDesc(item.loadType),
            item.loadStatus,
            item.driverGroup,
            item.loadIdAssigned,
            dateFormat.date(item.etaDate),
            dateFormat.date(item.deliveryDate),
            this.getMasterDataName('EndOutlet', 'item.endOutlet'),
            item.scaleTicket,
            item.totalBales,
            item.totalWeight,
            item.weightUnit,
            item.haulerId,
            item.driverId,
            dateFormat.date(item.deliveryStart),
            dateFormat.time(item.deliveryStart),
            dateFormat.time(item.deliveryDate),
            item.qcStatus,
            item.createdBy,
            dateFormat.date(item.createdAt),
            dateFormat.time(item.createdAt),
            item.confirmedBy,
            dateFormat.date(item.confirmedAt),
            dateFormat.time(item.confirmedAt),
            item.updatedBy,
            dateFormat.date(item.updatedAt),
            dateFormat.time(item.updatedAt),
          ]);

        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },
      doConfirm() {
        _(this.getSelectedItems)
          .each((item) => {
            item.confirmed = true;
            if (item.loadStatus === 'C' || item.loadStatus === 'X') {
              item.loadStatus = 'Y';
            } else if (item.loadStatus === '1') {
              item.loadStatus = '9';
            }
          });
      },
      doUnConfirm() {
        _(this.getSelectedItems)
          .each((item) => {
            item.confirmed = false;
            if (item.loadStatus === 'Y') {
              item.loadStatus = 'X';
            } else if (item.loadStatus === '9') {
              item.loadStatus = '1';
            }
          });
      },
      doChange() {
        _(this.getSelectedItems)
          .each((item) => {
            item.isChanging = true;
          });
      },
      doNew() {
        const userProfile = this.getUserProfile;
        this.loads = [];
        this.loads.unshift({
          isNew: true,
          loadIdForSort: `${Math.random() * 99999999}`,
          selected: true,
          loadIdAssigned: null,
          etaDate: new Date(),
          loadStatus: '1',
          driverId: null,
          driverGroup: null,
          deliveryStartDateString: dateFormat.date(new Date()),
          deliveryStartTimeString: '00:00',
          deliveryDateString: dateFormat.date(new Date()),
          deliveryTimeString: '00:00',
          haulerId: userProfile.companyId,
          totalBales: null,
          totalWeight: null,
          photos:[],
          weightUnit: 'LB',
          scaleTicket: null,
        });
        console.log(this.loads.length)
      },
      removeNewItem(item) {
        this.loads = _(this.loads)
          .without(item);
      },
      doSave() {
        const combineDateAndTime = (date, time) => {
          if (!date) {
            return null;
          }
          const dateString = moment(date)
            .format('YYYYMMDD');
          const timeString = time || '00:00';
          return moment(dateString + timeString, 'YYYYMMDDHHmm')
            .toDate();
        };

        const requestLoads = _(this.getSelectedItems)
          .map(it => ({
            isNew: it.isNew,
            confirmed: it.confirmed,
            driverId: it.driverId,
            updateDriverId: it.updateDriverId,
            loadIdAssigned: it.loadIdAssigned,
            driverGroup: it.driverGroup,
            haulerId: it.haulerId,
            etaDate: it.etaDate,
            deliveryStart: combineDateAndTime(it.deliveryStartDateString, it.deliveryStartTimeString),
            deliveryDate: combineDateAndTime(it.deliveryDateString, it.deliveryTimeString),
            totalBales: it.totalBales,
            totalWeight: it.totalWeight,
            scaleTicket: it.scaleTicket,
            weightUnit: it.weightUnit,
            loadStatus: it.loadStatus,
            endOutlet: it.endOutlet,
            qc: it.qc,
            qcStatus: it.qcStatus,
          }));

        const invalidItems = this.checkSaveLoadRequest(requestLoads);

        if (invalidItems.length > 0) {
          return;
        }

        this.$store.dispatch('saveLoads', { loads: requestLoads })
          .then(() => {
            this.doSearch();
          });
      },
      checkSaveLoadRequest(requests) {
        return _(requests)
          .filter((it) => {
            const errs = [];
            const tomorrow = moment()
              .startOf('day')
              .add(1, 'day');
            if (moment(it.deliveryDate)
              .isAfter(tomorrow)) {
              errs.push('DeliveryDate should between 60 days ago to today.');
            }
            const sixtyDaysAgo = moment()
              .startOf('day')
              .add(-60, 'day');
            if (moment(it.deliveryDate)
              .isBefore(sixtyDaysAgo)) {
              errs.push('DeliveryDate should between 60 days ago to today.');
            }
            const { length } = (it.loadIdAssigned || '');
            if (length < 1 || length > 20) {
              errs.push('LoadId should between 1~20 digits.');
            }
            // if (!it.totalWeight || it.totalWeight < 25000 || it.totalWeight > 45000) {
            //   errs.push('Total weight should between 25000~45000');
            // }
            if (it.isNew) {
              if (!it.driverId) {
                errs.push('Driver is required.');
              }
              if (!it.scaleTicket) {
                errs.push('Scale Ticket is required.');
              }
            }


            if (errs.length > 0) {
              window.alert(_(errs)
                .uniq()
                .join("\r\n"));
            }
            return errs.length > 0;
          });
      },
      handleAllItemSelectedChanged() {
        if (this.allItemsSelected === true) {
          _(this.loads)
            .chain()
            .filter(it => !it.confirmedBy)
            .each((it) => {
              it.selected = true;
            });
        } else {
          _(this.loads)
            .chain()
            .each((it) => {
              it.selected = false;
            });
        }
      },
      toggleItemPhoto(photos) {
        this.photos = photos;
        this.isPictureModalShowing = true;
      },
    },

  };

</script>
